module.exports = __webpack_public_path__ + "static/media/facebook.b1a02ca6.svg";